import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserIdService {
  private readonly storageKey = 'app_browser_instance_id';
  private instanceId: string;

  constructor() {
    let id = sessionStorage.getItem(this.storageKey);
    if (!id) {
      id = this.generateUniqueId();
      sessionStorage.setItem(this.storageKey, id);
    }
    this.instanceId = id;
  }

  getInstanceId(): string {
    return this.instanceId;
  }

  generateUniqueId(): string {
    const browser = this.detectBrowserName();
    const uuid = crypto.randomUUID();
    return `${browser}-${uuid}`;
  }

  private detectBrowserName(): string {
    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes('firefox')) return 'firefox';
    if (ua.includes('edg')) return 'edge';
    if (ua.includes('chrome')) return 'chrome';
    if (ua.includes('safari')) return 'safari';

    return 'other-browser';
  }
}
